// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  justify-content: center;
  align-items: center;
  height: 100%;
}

img {
  width: 3rem;
  height: 4rem;
}

span {
  text-align: center;
}

ion-button {
  --background: black;
  --background-activated:black;
  --border-radius: 8px;
  width: 100%;
  height: 3rem;
}

i.material-icons {
  position: absolute;
  top: 0;
  right: 0;
  padding: 1rem;
  border-radius: 8px;
  cursor: pointer;
}
i.material-icons:hover {
  background: rgba(128, 128, 128, 0.322);
  transition: 0.3s ease-in-out;
}
i.material-icons:active {
  opacity: 0.5;
}`, "",{"version":3,"sources":["webpack://./src/app/components/prompt/prompt.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,mBAAA;EACA,4BAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;AACJ;;AAEA;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;AACJ;AAAI;EACI,sCAAA;EACA,4BAAA;AAER;AAAI;EACI,YAAA;AAER","sourcesContent":["div{\n    padding: 1rem;\n    display: flex;\n    flex-direction: column;\n    gap: 2rem;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n}\n\nimg{\n    width: 3rem;\n    height: 4rem;\n}\n\nspan{\n    text-align: center;\n}\n\nion-button{\n    --background: black;\n    --background-activated:black;\n    --border-radius: 8px;\n    width: 100%;\n    height: 3rem;\n}\n\ni.material-icons{\n    position: absolute;\n    top: 0;\n    right: 0;\n    padding: 1rem;\n    border-radius: 8px;\n    cursor: pointer;\n    &:hover{\n        background: rgba(128, 128, 128, 0.322);\n        transition: 0.3s ease-in-out;\n    }\n    &:active{\n        opacity: 0.5;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
